import React, { useState } from 'react';
import cn from 'classnames';
import * as PropTypes from 'prop-types';

import Icon from '../../../../Icon';
import PrivacyIcon from '../../../../PrivacyIcon';
import { humanizeDate } from '../../../../../utils/appointments/dateFilter';
import { makeSafePharmacyAddress } from '../../../../../utils/appointments/makeSafePharmacyAddress';

import styles from '../styles.styl';

const Prescription = ({ prescription, formatMessage }) => {
  const [isDetailed, setIsDetailed] = useState(false);

  const pharmacyTitle = formatMessage({
    id: 'patient.portal.medications.pharmacy',
  });
  const phoneTitle = formatMessage({
    id: 'common.phone',
  });
  const directionTitle = formatMessage({
    id: 'patient.portal.medications.directions',
  });

  const safePharmacyAddress = makeSafePharmacyAddress({
    city: prescription.ccdPharmacy.city,
    state: prescription.ccdPharmacy.state,
    address: prescription.ccdPharmacy.address1,
  });

  return (
    <div className={cn(styles.prescription, { [styles.bgGrey]: isDetailed })}>
      <div className={styles.prescriptionHeader}>
        <div className={styles.prescriptionHeaderLeft}>
          <Icon size={32} name="icon-medications" className={styles.iconType} />
          <div className={styles.drugBlock}>
            <div>
              {prescription.name}, {prescription.quantityAmount}
              {prescription.quantityUnit}
              <PrivacyIcon
                show={prescription.isPrivate}
                className={styles.privacyIcon}
              />
            </div>
            <span className={styles.providerName}>
              {prescription.providerProfile.firstName}{' '}
              {prescription.providerProfile.lastName}{' '}
              {prescription.providerProfile.credential}
            </span>
          </div>
        </div>
        <div className={styles.prescriptionHeaderRight}>
          <div className={styles.date}>
            <div>
              {humanizeDate(prescription.prescribedDate, formatMessage)}
            </div>
          </div>
          <Icon
            size={16}
            className={styles.iconArrow}
            onClick={() => setIsDetailed(!isDetailed)}
            name={isDetailed ? 'icon-arrow-up' : 'icon-arrow-down'}
          />
        </div>
      </div>

      {isDetailed && (
        <div className={styles.prescriptionDetails}>
          <div className={styles.prescriptionDetailsItem}>
            <span className={styles.detailsTitle}>{directionTitle}</span>
            <div className={styles.detailsData}>
              <div>{prescription.frequency}</div>
            </div>
          </div>
          <div className={styles.prescriptionDetailsItem}>
            <span className={styles.detailsTitle}>{pharmacyTitle}</span>
            <div className={styles.detailsData}>
              <div>
                {prescription.ccdPharmacy.name && prescription.ccdPharmacy.name}
                , {safePharmacyAddress}
              </div>
            </div>
          </div>
          <div className={styles.prescriptionDetailsItem}>
            <span className={styles.detailsTitle}>{phoneTitle}</span>
            <span className={styles.detailsData}>
              {prescription.ccdPharmacy.phone}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

Prescription.propTypes = {
  formatMessage: PropTypes.func,
  prescription: PropTypes.object,
};

export default Prescription;



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/VisitPrescriptions/Prescription/index.jsx